import { DateTime } from "luxon";
import React, { useEffect } from "react";
import { isAllDayBasedOnTimes } from "../../web-app-calendar/hooks/useEditExistingEvent.util";
import { EventElementsWrap } from "../atoms/EventElementsWrap";
import { useReadEventTimeDetails, useUpdateEventTimeDetails } from "../hooks/EventCardContext";
import { isValidTimeRange } from "../utils/eventCardTime.util";
import { ECTime } from "./ECTime";

export const Time = ({
  readOnly,
  updateFlexToggle,
  timesHaveChanged = false,
  hideUIWrapper = false,
}: {
  readOnly: boolean;
  updateFlexToggle?: () => void;
  timesHaveChanged?: boolean;
  hideUIWrapper?: boolean;
}) => {
  const { startTime, endTime, isAllDay, timeError } = useReadEventTimeDetails();
  const { setStartTime, setEndTime, setIsAllDay, setTimeError } = useUpdateEventTimeDetails();

  // Determine if new times make the event "all day"
  const isAllDayFromTimes = isAllDayBasedOnTimes(startTime, endTime);

  useEffect(() => {
    setIsAllDay(isAllDayFromTimes);
  }, [isAllDayFromTimes, setIsAllDay]);

  const validateAndCallback = (newStart?: DateTime, newEnd?: DateTime) => {
    if (newStart && newEnd) {
      if (isValidTimeRange(newStart, newEnd)) {
        setTimeError(null);
        setStartTime(newStart);
        setEndTime(newEnd);
        if (
          newStart.toMillis() !== startTime?.toMillis() ||
          newEnd.toMillis() !== endTime?.toMillis()
        ) {
          updateFlexToggle?.();
        }
      } else {
        setTimeError("Start time must be before end time.");
      }
    } else if (newStart && !newEnd) {
      setStartTime(newStart);
      if (newStart.toMillis() !== startTime?.toMillis()) {
        updateFlexToggle?.();
      }
    } else if (!newStart && newEnd) {
      setEndTime(newEnd);
      if (newEnd.toMillis() !== endTime?.toMillis()) {
        updateFlexToggle?.();
      }
    }
  };

  return hideUIWrapper ? (
    <ECTime
      startTime={startTime}
      endTime={endTime}
      readOnly={readOnly}
      onChange={validateAndCallback}
      isAllDay={isAllDay}
      timeError={timeError}
      setTimeError={setTimeError}
    />
  ) : (
    <EventElementsWrap name="time" showChanges={timesHaveChanged}>
      <ECTime
        startTime={startTime}
        endTime={endTime}
        readOnly={readOnly}
        onChange={validateAndCallback}
        isAllDay={isAllDay}
        timeError={timeError}
        setTimeError={setTimeError}
      />
    </EventElementsWrap>
  );
};
